import { createContext } from 'react';

const AppContext = createContext({ isInWebView: false, currentUser: null, serviceDesk: null });

export default AppContext;


